import { compose, lifecycle } from 'recompose';
import {
  addProps,
  addIntlProps,
  renderNothingIfPropFalsy,
} from 'utils/recompose';
import { injectIntl } from 'react-intl';
import messages from './messages';
import { connect } from 'react-redux';
import { selectedSeriesId } from 'reducers/seriesPipeline/selectors';
import { mini } from 'reducers/dashboard/selectors';
import { announcementsLoading } from 'reducers/loading/selectors';
import combineSelectors from 'utils/combineSelectors';
import {
  fetchAnnouncements,
  closeAnnouncements,
} from 'reducers/announcements/actions';
import {
  unreadMessages,
  announcementsVisible,
} from 'reducers/announcements/selectors';

export function componentDidMount() {
  this.props.fetchAnnouncements();
}

const mapStateToProps = combineSelectors({
  selectedSeriesId,
  unreadMessages,
  announcementsVisible,
  mini,
  announcementsLoading,
});

export const redirectToAnnouncements = ({
  location,
  unreadMessages,
  announcementsVisible,
}) =>
  location.pathname !== '/dashboard' &&
  unreadMessages &&
  unreadMessages.length > 0 &&
  announcementsVisible === true;

export const hasNewAnnouncements = ({ unreadMessages }) =>
  unreadMessages && unreadMessages.length > 0;

export const unreadMessagesCount = ({ unreadMessages }) =>
  unreadMessages && unreadMessages.length;

export const hasQuotaDetail = ({ selectedSeriesId }) => !!selectedSeriesId;

export const isLoading = ({ announcementsLoading }) => announcementsLoading;

export default compose(
  injectIntl,
  addIntlProps({ messages, propNames: ['welcome'] }),
  connect(
    mapStateToProps,
    {
      fetchAnnouncements,
      closeAnnouncements,
    },
  ),
  lifecycle({ componentDidMount }),
  addProps({
    hasQuotaDetail,
    hasNewAnnouncements,
    redirectToAnnouncements,
    unreadMessagesCount,
    isLoading,
  }),
  renderNothingIfPropFalsy('unreadMessages'),
);
